(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("osjsDialogs", [], factory);
	else if(typeof exports === 'object')
		exports["osjsDialogs"] = factory();
	else
		root["osjsDialogs"] = factory();
})(window, function() {
return 